import * as defaultUtils from "./defaultUtils";
import validateForm from "./validateForm";
import Tip from "./msg";

function formatTime(s) {
    if (s === undefined) return 0;
    const hours = parseInt(s / 3600);
    const minutes = parseInt((s % 3600) / 60);
    const seconds = parseInt(s % 60);
    return seconds == 0 ? 0 : (`${hours} 时 ${minutes} 分 ${seconds}秒`);
}

export default {
    ...defaultUtils,
    validateForm,
    formatTime,
    Tip
}


// WEBPACK FOOTER //
// ./src/utils/index.js